// Great-circle distance between two WGS84 coordinates, in meters (haversine).
// Used by the geofence: compare a clock-in GPS fix against the location's
// configured coordinates. Accurate to well within the tens-of-meters radii we
// care about for "are you physically at the restaurant".

const EARTH_RADIUS_M = 6_371_000

function toRad(deg: number): number {
  return (deg * Math.PI) / 180
}

export type LatLng = { lat: number; lng: number }

export function haversineMeters(a: LatLng, b: LatLng): number {
  const dLat = toRad(b.lat - a.lat)
  const dLng = toRad(b.lng - a.lng)
  const lat1 = toRad(a.lat)
  const lat2 = toRad(b.lat)
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2
  return 2 * EARTH_RADIUS_M * Math.asin(Math.min(1, Math.sqrt(h)))
}

/** True when `point` is within `radiusM` of `center`. */
export function isWithinRadius(center: LatLng, point: LatLng, radiusM: number): boolean {
  return haversineMeters(center, point) <= radiusM
}

// ── Marketplace "cerca de ti" (plan F3) ─────────────────────────────────────
// Misma fórmula del geofence, en la unidad que habla el directorio (millas).

const METERS_PER_MILE = 1609.344

/** Distancia gran-círculo en millas entre dos coordenadas WGS84. */
export function distanceMiles(a: LatLng, b: LatLng): number {
  return haversineMeters(a, b) / METERS_PER_MILE
}

export type DistanceBand = "<1 mi" | "~2 mi" | "~5 mi" | "~10 mi" | "10+ mi"

/**
 * Banda de distancia para UI. Bandas, NUNCA decimales: cuando el origen o el
 * destino salen de un centroide de ZIP (no de coordenadas reales), imprimir
 * "3.2 mi" sería precisión inventada — el centroide ORDENA, no imprime
 * precisión. Los cortes son puntos medios aproximados entre etiquetas
 * (1 / 3.5 / 7.5 / 12.5), así cada distancia cae en la etiqueta más honesta.
 */
export function distanceBand(mi: number): DistanceBand {
  if (mi < 1) return "<1 mi"
  if (mi < 3.5) return "~2 mi"
  if (mi < 7.5) return "~5 mi"
  if (mi < 12.5) return "~10 mi"
  return "10+ mi"
}
